<template>
  <div class="movement-history-main">
    <div
      id="gallery-popup"
      @keyup.right="displayNext()"
      @keyup.left="displayPrev()"
      :style="'display:' + galleryPopupDisplay"
    >
      <div id="gallery-popup-close-button" @click="galleryPopupDisplay = 'none'">X</div>
      <div id="container">
        <div id="gallery" class="gallery">
          <div id="large">
            <div class="img-container">
              <img id="large-img" :src="galleryPics[selectedPicIndex]" />
            </div>
            <div class="arrow-buttons-container">
              <div class="prev" @click="displayPrev()">&lt;</div>
              <div class="next" @click="displayNext()">&gt;</div>
            </div>
          </div>
          <div id="thumbs">
            <img
              v-for="(pic, index) in galleryPics"
              :key="pic"
              class="thumbnail"
              @click="selectedPicIndex=index"
              :style="'background-color:' + getThumbnailBackgroundColor(index)"
              :src="pic"
              :id="'thumbnail' + index"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="left-container">
      <div class="section-title">
        <div class="title-text">Movement Date</div>
        <button @click="refreshClicked">Refresh</button>
      </div>

      <div class="date-refresh-section">
        <div class="from-to-date">
          <DateTimePicker
            placeholder="From"
            title="From"
            :value.sync="fromDate"
          />
          <DateTimePicker
            placeholder="To"
            title="To"
            :value.sync="toDate"
          />
        </div>
        <div></div>
      </div>

      <div class="vehicle-dropdown-section">
        <Dropdown
          placeholder="Vehicle"
          :items="vehicles"
          itemKey="Keyname"
          :selectedObject.sync="selectedVehicle"
        />

        <div class="vehicle-description">
          Category: {{ fullVehicleData ? fullVehicleData["Category"] : '' }} <br />
          Type: {{ fullVehicleData ? fullVehicleData["Type"] : '' }} <br />
          Year: {{ fullVehicleData ? fullVehicleData["Year"] : '' }} <br />
          Ownership: {{ fullVehicleData ? fullVehicleData["Ownership"] : '' }} <br />
          Sideloader: {{ fullVehicleData ? selectedVehicle["Sideloader"] : '' }} <br />
          Model: {{ fullVehicleData ? fullVehicleData["Model"] : '' }} <br />
          <div v-if="fullVehicleData && 'Team' in fullVehicleData" >
            Team: {{ fullVehicleData["Team"] }} <br />
          </div>
          <div v-if="fullVehicleData && 'Driver' in fullVehicleData">
            Driver: {{ fullVehicleData["Driver"] }} <br />
          </div>
        </div>
      </div>
      <div class="extra-info">
        Total Waiting Time: <br />
        {{ totalWaitTime }} 
        <!-- <br/> ({{ waitTimePercentage.toFixed(2) }}%)  -->

        <div class="gauge-container">
          <div id="time-gauge" class="progress-bar" :style="'width:' + waitTimePercentage + '%'"></div>
        </div>
        <div>{{ waitTimePercentage.toFixed(2) }}%</div>

        <br />

        <div>Total km: {{ totalKm.toFixed(2) }}</div>
        <div>
          Total unproductive km: {{ totalUnproductiveKm.toFixed(2) }} <br />
          <!-- ({{ unproductiveKmPercentage.toFixed(2) }}%)  -->
        </div>

        <div class="gauge-container">
          <div id="km-gauge" class="progress-bar" :style="'width:' + unproductiveKmPercentage + '%'"></div>
        </div>
        <div>{{ unproductiveKmPercentage.toFixed(2) }}%</div>

        <br />

        <div>
          Total stop time: <br />
          {{ totalStopTime }} <br />
        </div>
        <div class="gauge-container">
          <div id="stop-time-gauge" class="progress-bar" :style="'width:' + stopTimePercentage + '%'"></div>
        </div>
        <div>{{ stopTimePercentage.toFixed(2) }}%</div>
        <button id="toggleStopMarkerButton" @click="toggleStopMarkers()">
          {{ stopPointToggleText }}
        </button>

        <div>
          <br />
          <Button
            @click="markerClicked(longestTripStartPoint)"
            class="longest-shortest-journey"
          >
            Longest journey: <br />
            {{ longestTrip.toFixed(2) }}km
          </Button>
          <br /><br />
          <Button
            @click="markerClicked(shortestTripStartPoint)"
            class="longest-shortest-journey"
          >
            Shortest journey: <br />
            {{ shortestTrip.toFixed(2) }}km
          </Button>
        </div>
      </div>

    </div>

    <div class="map">
      <CustomMap
        v-if="showCustomMap"
        :mapObject.sync="myMap"
        :markers.sync="mapMarker"
        ref="vehicleMap"
        viewMode
        hideSlot
        @markerClicked="markerClicked"
      />
    </div>
    <div v-if="!TAS || TAS.length === 0" class="chronology">
      <div style="font-weight: bold; font-size: 1.25em; margin-bottom: 20px">
        Chronology of Events.
      </div>
      <div>No data available.</div>
    </div>

    <div v-else class="chronology">
      <div style="font-weight: bold; font-size: 1.25em; margin-bottom: 20px">
        Chronology of Events
      </div>

      <div v-for="(journey) in chronologyOfEventsCards" :class="'card-container' + ' ' + 'a' + journey['GUID']" :key="journey['UniqueId'].toString()">
        <div v-if="journey['Type'] === 'Journey'" :class="'event-container' + ' ' + 'a' + journey['GUID']" :style="'background-color:' + cardBackgroundColor(journey['GUID'])">
          <div v-for="(event,eventType) in journey['Events']" class="card-box" :key="'card' + eventType + journey['GUID']">
            <div class="card" @click="cardItemClicked(event['In'] ? event['In'] :event['Out'])">

              <div class="card-title">

                <div class="remark">
                  <div v-if="event['In']">
                    {{ event['In']["Event Type"] }}<br />{{ event['In']["Cust Short Name"] }}
                  </div>
                  <div v-else-if="event['Out']">
                    {{ event['Out']["Event Type"] }}<br />{{ event['Out']["Cust Short Name"] }}
                  </div>
                </div>

                <div class="time">
                  <div v-if="!event['In']">In: -</div>
                  <div v-else @click.stop="cardItemClicked(event['In'])" class="underline">
                    In: {{ new Date(event['In']["Time"]).formatString("yyyy-MM-dd HH:mm") }}
                    <br />
                  </div>
                  <div v-if="!event['Out']">Out: -</div>
                  <div v-else @click.stop="cardItemClicked(event['Out'])" class="underline">
                    Out: {{ new Date(event['Out']["Time"]).formatString("yyyy-MM-dd HH:mm") }}
                  </div>
                </div>

                <div class="geofence-time" :set="geoTimes = getGeofenceTimesForJourney(journey['GUID'])">
                  <template v-if="geoTimes.length > 0">
                    <div
                      v-for="(geo, geoIndex) in geoTimes"
                      :key="'geo_card_' + journey['GUID'] + '_' + geoIndex"
                      class="geofence-time-entry"
                    >
                      <!-- <div v-if="geo.in" :style="'color:' + geofenceInColor"> -->
                      <div v-if="geo.in">
                        GPS In: {{ new Date(geo.in).formatString("yyyy-MM-dd HH:mm") }}
                      </div>
                      <!-- <div v-if="geo.out" :style="'color:' + geofenceOutColor"> -->
                      <div v-if="geo.out">
                        GPS Out: {{ new Date(geo.out).formatString("yyyy-MM-dd HH:mm") }}
                      </div>
                    </div>
                  </template>
                </div>

                <div class="tooltip-container">
                      <Tooltip v-if="shouldShowTooltip(event)" position="top" icon="https://dsmlib.logistics.systems/Icons/warning.png" tooltipText="GPS Data Unavailable for This Event" />
                </div>

              </div>
              
              <div class="card-paragraph">
                <div class="details">
                  <div v-if="event['In']">
                    {{ event['In']["Consignment #"] }} - {{ event['In']["Container #"] }} <br />
                    {{ event['In'][`${eventType} Company`] }} ({{ event['In'][`${eventType}`] }}) -
                    {{ event['In'][`${eventType} City`] }}
                  </div>
                  <div v-else-if="event['Out']">
                    {{ event['Out']["Consignment #"] }} - {{ event['Out']["Container #"] }} <br />
                    {{ event['Out'][`${eventType} Company`] }} ({{ event['Out'][`${eventType}`] }}) -
                    {{ event['Out'][`${eventType} City`] }}
                  </div>
                </div>

                <div class="tas-pic-container" :set="pics = getTASPicList(journey['GUID'],eventType)" v-if="getTASPicList(journey['GUID'],eventType)">
                  <img class="tas-pic" @click="startGallery(getTASPicList(journey['GUID'],eventType))" :src="pics[0]"/>
                  <div v-if="pics.length > 1" class="number">
                    {{ pics.length }}
                  </div>
                </div>
              </div>
            </div>

            <div class="card red" @click="cardItemClicked(event['In']?event['In']:event['Out'])" style='margin-left:10px'>
              <div class="card-title">
                <div class="remark">
                  Wait
                  <span v-if="event['In'] && event['Out']">
                    {{ getWaitTime(event['In']) }}
                  </span>
                  <span v-else>-</span>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div v-else :class="'event-container ' + 'a' + journey['GUID']" :style="'background-color:' + cardBackgroundColor(journey['GUID']) " 
          :set="(event = journey['Events'])" @click.stop="cardItemClicked(journey['Events'])">
          <div class="card-box">

            <!-- <div v-if="journey['Type'] === 'Clock Out'" style='width: 50%;'></div> -->
            
            <div :class="'card' + (journey['Type'] === 'Clock In'? ' clock-in' : ' clock-out')">

              <div class="card-title">
                <div class="remark">{{ event['Event Type'] }}</div>
                <div class="time">
                  {{ new Date(event["Time"]).formatString("yyyy-MM-dd HH:mm") }}
                </div>
              </div>
              
              Odometer: {{ event["Odometer"] }}

            </div>
          </div>
        </div>

        <div class="space">
          <!-- <br /> -->
          <hr />
          <!-- <br /> -->
        </div>
      </div>
    </div>


    <div class="timeline-container">
      <div id="timeline-title-container">
        <div id="timeline-title">
          Timeline
        </div>
        <div id="legend-title" @mouseover="showLegend=true" @mouseleave="showLegend=false">
          Legend
          <div v-show="showLegend" id="legend-container">
            <div class="legend-item">
              <div class="legend-symbol" :style="'background-color:' + timelineProductiveColor"></div>
              <div class="legend-description">Productive</div>
            </div>
            <div class="legend-item">
              <div class="legend-symbol" :style="'background-color:' + timelineUnproductiveColor"></div>
              <div class="legend-description">Unproductive</div>
            </div>
            <div class="legend-item">
              <div class="legend-symbol" :style="'background-color:' + timelineClockOutColor"></div>
              <div class="legend-description">Clocked out</div>
            </div>
            <div class="legend-item">
              <div class="legend-symbol" :style="'background-color:' + geofenceInColor"></div>
              <div class="legend-description">Geofence in</div>
            </div>
            <div class="legend-item">
              <div class="legend-symbol" :style="'background-color:' + geofenceOutColor"></div>
              <div class="legend-description">Geofence out</div>
            </div>
            <div class="legend-item">
              <div class="legend-symbol"><img :src="deliveryTruckIcon" /></div>
              <div class="legend-description">Delivery</div>
            </div>
            <div class="legend-item">
              <div class="legend-symbol"><img :src="collectionTruckIcon" /></div>
              <div class="legend-description">Collection</div>
            </div>
            <div class="legend-item">
              <div class="legend-symbol"><img :src="clockInIcon" /></div>
              <div class="legend-description">Clock in</div>
            </div>
            <div class="legend-item">
              <div class="legend-symbol"><img :src="clockOutIcon" /></div>
              <div class="legend-description">Clock out</div>
            </div>
          </div>
        </div>
        
      </div>
      <div v-if="timelinePeriodList.length > 0" id="timeline">
        <div class="timeline-time"> {{ fromDate.formatString("HH:mm") }} </div>

        <!-- <div class="unproductive" style="height: 5vh;"></div> -->

        <!-- Add an 'a' before the GUID class name, because class names cannot start with numbers. Some GUID start with numbers. -->
        <div v-for="(period, index) in timelinePeriodList" :key="period['UniqueId'].toString()" :class="'a' + period['GUID'] + ' timeline-bar '"
          :style="
            'height: ' + period['Period'] + 'vh;' +
            'outline: ' + (period['Type'] === 'unproductive' ? 'none' : timelineOutline(period['GUID'])) + ';' +
            'z-index:' + (period['Type'] === 'unproductive' ? '1' : timelineZIndex(period['GUID'])) + ';' + 
            'background-color:' + getTimelineBarColor(period['Type'])
          "
          @click="periodClicked(period)"
        >
          <div
            class="time-display"
            v-if="period['Period'] > 0.7 /*&& !lastIsClock(index)*/  && index !== 0 /*|| period['Type'] === 'clock'*/"
          >
            <div class="time">
              {{ period["Start"]["Time"].formatString("HH:mm") }}
              <div
                v-if="
                  //period['Type'] === 'clock-in' ||
                  period['Type'] === 'clock' ||
                  period['Start']['Event Type'].includes('Clock')
                "
              >
                <img :src="getPicSrc(period)" width="15" />
              </div>
            </div>
            <div class="right-line"></div>
          </div>

          <div v-if="period['Period'] > 0.7 && (period['Type'] === 'productive' || period['Type'] === 'clock')">
            <div class="left-line"></div>
            <div class="pic-container">
              <img
                :set="(picSrc = getPicSrc(period))"
                :src="picSrc"
                width="25"
              />
              <div
                v-if="picSrc === deliveryTruckIcon"
                class="event-type"
              >
                {{ getPeriodEventType(period) }}
              </div>
              <div v-else-if="picSrc === collectionTruckIcon" class="event-type right">
                {{ getPeriodEventType(period) }}
              </div>
            </div>
            <!-- <img
              width: 30;
              :src="getPicSrc(period)"
            > -->
          </div>

          <!-- Geofence GPSLogTime -->
          <div
            v-for="(geoEntry, geoIndex) in getGeofenceInEntriesInPeriod(period)"
            :key="'geo_in_' + period['UniqueId'] + '_' + geoIndex"
            class="geofence-marker-container"
            :style="'top: ' + getGeofenceOffsetInPeriod(period, geoEntry['GPSLogTime']) + '%;'"
            @click.stop
          >
            <div class="geofence-line geofence-line-in">
              <span class="geofence-hover-label">
                {{ new Date(geoEntry['GPSLogTime']).formatString("HH:mm") }} IN
              </span>
            </div>
          </div>

          <!-- Geofence GPSLogTimeOut -->
          <div
            v-for="(geoEntry, geoIndex) in getGeofenceOutEntriesInPeriod(period)"
            :key="'geo_out_' + period['UniqueId'] + '_' + geoIndex"
            class="geofence-marker-container"
            :style="'top: ' + getGeofenceOffsetInPeriod(period, geoEntry['GPSLogTimeOut']) + '%;'"
            @click.stop
          >
            <div class="geofence-line geofence-line-out">
              <span class="geofence-hover-label">
                {{ new Date(geoEntry['GPSLogTimeOut']).formatString("HH:mm") }} OUT
              </span>
            </div>
          </div>

        </div>

        <div class="timeline-time"> {{ toDate.formatString("HH:mm") }} </div>
      </div>
    </div>

  </div>
  <!-- </div> -->
</template>

<script>
/* eslint-disable */
export default {
  components: {},
  data: function () {
    return {

      fullVehicleData: {Vehicle: {}},

      fromDate: new Date(
        `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${
          new Date().getDate() - 1
        } 00:00`
      ),
      toDate: new Date(
        `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${
          new Date().getDate() - 1
        } 23:59`
      ),

      timeGauge: null,

      selectedVehicle: {},

      chronologyOfEventsCards: [],
      timelinePeriodList: [],
      showLegend: false,
      selectedGUID: '',

      timelineProductiveColor: '#c4d0fd', // blue
      timelineUnproductiveColor: 'rgb(255, 80, 80)', // red
      timelineClockOutColor: 'grey',
      geofenceInColor: '#5bb450', //green
      geofenceOutColor: '#ffa500', //orange
      timelineHighlightColor: 'bisque',
      productivePathColor: 'green',
      unproductivePathColor: '#FF0000', // red

      deliveryTruckIcon: 'https://i.imgur.com/JNHvjzI.png',
      collectionTruckIcon: 'https://i.imgur.com/wjW0frO.png',
      clockOutIcon: 'https://i.imgur.com/hvuqPZM.png',
      clockInIcon: 'https://i.imgur.com/fgYOrwa.png',
      pickupIcon: 'https://i.imgur.com/iKxsBVx.png',
      dropoffIcon: 'https://i.imgur.com/SvN3TuO.png',
      stopPointIcon: 'https://i.imgur.com/cQEyMEE.png',

      GUIDList: [],
      GUIDStartAndEndPoints: null,
      GUIDPath: null,
      allGUIDPaths: [],
      productivePoints: null,
      productivePath: [],
      GUIDProductivePath: null,

      vehicle: [],
      vehicles: [],
      TASMarkers: [],
      GPSPath: null,
      GPSLogCoordinates: [],
      selectedMarker: null,
      myMap: null,
      TASDetails: [],
      infoWindow: null,
      mapMarker: [],
      destGeofenceList: [],
      showCustomMap: false,

      totalWaitTimeInMs: 0,
      waitTimePercentage: 0,

      averageKm: 0,
      shortestTripStartPoint: null,
      longestTripStartPoint: null,
      stopTimePercentage: 0,
      stopPoints: [],
      stopPointMarkers: [],
      stopPointToggleText: 'Hide stop markers',

      galleryPopupDisplay: 'none',
      galleryPics: [],
      selectedPicIndex: 0,

      infoWindowOpened: null,
    };
  },
  computed: {
    allMarkersOnMap: function () {
      return [...this.TASMarkers,...this.stopPointMarkers,...this.destGeofenceList];
    },

    allPaths: function() {
      return[this.GPSPath, ...this.allGUIDPaths];
    },
    
    GPSLog: function () {
      let GPSLog = this.fullVehicleData?.['GPSLog'];
      if(!GPSLog){
        return [];
      }
      return GPSLog;
    },
    
    TAS: function () {
      let TAS = this.fullVehicleData?.['TAS'];
      if(!TAS){
        return [];
      }
      // remove duplicate TAS Events.
      // some journeys have duplicate TAS events e.g. 2 PUO , 2 PUI etc.
      if(TAS) {
        TAS = TAS.reduce(function (p, c) {
            if (
              !p.some(function (el) {
                return (
                  el.Remarks === c.Remarks && el.JourneyGUID === c.JourneyGUID
                );
              })
            )
              p.push(c);
            return p;
          }, []);
      }
      return TAS;
    },
    
    clockInOut: function () {
      let clockInOut = this.fullVehicleData['ClockInOut'];
      if(!clockInOut) {
        return [];
      }
      return clockInOut;
    },
    
    TASPics: function () {
      let TASPics = this.fullVehicleData['TASPic'];
      if(!TASPics)
       return [];
      TASPics = this.groupTasPics(TASPics);
      return TASPics;
    },
    geofenceInOut: function () {
      let geofenceInOut = this.fullVehicleData['GeofenceInOut'];
      if(!geofenceInOut){
       return [];
      }
      return geofenceInOut;
    },

    totalWaitTime: function () {
      //const waitTimeMs = this.getTotalWaitTime();
      //const formattedWaitTime = this.msToHrAndMin(waitTimeMs);
      return this.msToHrAndMin(this.totalWaitTimeInMs);
    },

    totalKm: function () {
      if(!this.GPSPath)
        return 0;
      return this.getPolylineLength(this.GPSPath);
    },

    totalUnproductiveKm: function () {
      let totalProductivekm = 0;
      
      this.allGUIDPaths.forEach(path => {
        totalProductivekm += this.getPolylineLength(path);
      })
      return this.totalKm - totalProductivekm;
    },

    unproductiveKmPercentage: function () {
      if(this.totalUnproductiveKm === 0 || this.totalKm === 0)
        return 0;

      return this.totalUnproductiveKm / this.totalKm * 100;
    },

    totalStopTime: function () {
      return this.getTotalStopTime();
    },

    longestTrip: function () {
      if(!this.allGUIDPaths)
        return 0;
      let high = 0;
      let longestTripGUID = '';

      this.allGUIDPaths.forEach(path => {
        let distance = this.getPolylineLength(path);
        if(distance > high) {
          high = distance;
          longestTripGUID = path['GUID'];
        }
      })

      this.longestTripStartPoint = this.TASMarkers.find(marker => marker['TASEvent']['JourneyGUID'] === longestTripGUID);

      return high;


    },

    shortestTrip: function () {
      if(!this.allGUIDPaths || this.allGUIDPaths.length === 0)
        return 0;
      let low = Infinity;
      let shortestTripGUID = '';

      this.allGUIDPaths.forEach(path => {
        let distance = this.getPolylineLength(path);
        if(distance < low) {
          low = distance;
          shortestTripGUID = path['GUID'];
        }
      })

      this.shortestTripStartPoint = this.TASMarkers.find(marker => marker['TASEvent']['JourneyGUID'] === shortestTripGUID);
      return low;
    }
    
  },
  props: {},
  methods: {
    isLatLonEmpty(lat, lon) {
        return (lat === '' || lat === '0.0000') && (lon === '' || lon === '0.0000');
    },
    shouldShowTooltip(event) {
        const inEmpty = event['In'] ? this.isLatLonEmpty(event['In']['Lat'], event['In']['Lon']) : true;
        const outEmpty = event['Out'] ? this.isLatLonEmpty(event['Out']['Lat'], event['Out']['Lon']) : true;
        return inEmpty && outEmpty;
    },
    //#region chronology of events functions

    structureTASForCards: function (TAS, clockInOut) {
        let events = TAS;
        if (clockInOut) {
            if (Array.isArray(clockInOut)) {
                clockInOut.forEach((o) => renameKey(o, "Clock Time", "Time"));
                clockInOut.forEach((o) => renameKey(o, "Event GUID", "JourneyGUID"));
            } else {
                renameKey(clockInOut, "Event GUID", "JourneyGUID");
                renameKey(clockInOut, "Clock Time", "Time");
            }
            events = TAS.concat(clockInOut);
        }

        events.forEach((event) => {
            event["Time"] = new Date(event["Time"]);
        });

        events.sort(function (a, b) {
            var keyA = new Date(a["Time"]);
            var keyB = new Date(b["Time"]);
            // Compare the 2 dates
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
        });

        events = groupBy(events, "JourneyGUID");
        events = groupTAS(events);

        // console.log("Cards data: ", events);
        return events;

        function renameKey(o, oldKey, newKey) {
            if (o.hasOwnProperty(newKey))
                return;
            if (oldKey !== newKey) {
                Object.defineProperty(
                    o,
                    newKey,
                    Object.getOwnPropertyDescriptor(o, oldKey)
                );
                delete o[oldKey];
            }
        }

        function groupBy(collection, property) {
            var result = [];
            var index = -1;
            var val = null;
            for (var i = 0; i < collection.length; i++) {
                if (collection[i][property] === val) {
                    result[index].push(collection[i]);
                } else {
                    index++;
                    val = collection[i][property];
                    result.push([collection[i]]);
                }
            }
            return result;
        }

        function groupTAS(events) {
            for (let i = 0; i < events.length; i++) {
                if(events[i][0]['Event Type'].includes('Clock')){
                    events[i] = {
                        'Type': events[i][0]['Event Type'],
                        'GUID': events[i][0]['JourneyGUID'],
                        'Events': events[i][0],
                        'UniqueId': 'clock_' + i
                    }
                    continue;
                }
                let pickup = {};
                let dropoff = {};
                let TASEventsList = {};

                let event = events[i];
                for (let i = 0; i < event.length; i++) {
                    if(event[i]['Remarks'].includes('PUI')){
                        pickup['In'] = event[i];
                    }
                    if(event[i]['Remarks'].includes('PUO')){
                        pickup['Out'] = event[i];
                    }
                    if(event[i]['Remarks'].includes('DOI')){
                        dropoff['In'] = event[i];
                    }
                    if(event[i]['Remarks'].includes('DOO')){
                        dropoff['Out'] = event[i];
                    }
                }

                if(!isEmpty(pickup)){
                  TASEventsList['Pickup'] = pickup;
                }

                if(!isEmpty(dropoff)){
                  TASEventsList['Dropoff'] = dropoff;
                }
                
                events[i] = {
                    'Type': 'Journey',
                    'GUID': event[0]['JourneyGUID'],
                    'Events':TASEventsList,
                    'UniqueId': 'journey_' + i
                }
            }
            return events;
            function isEmpty(obj) {
                return Object.keys(obj).length === 0;
            }

        }
    },

    cardItemClicked: async function (data) {
      // Location button is clicked
      // console.log("Card item clicked; ", data);
      let GUID = data['JourneyGUID'];
      let remarks = data['Remarks'];

      if(data['Event Type'].includes('Clock')){
        if(this.infoWindow){
          this.infoWindow.close();
          this.resetMap();
        }
        this.highlightCardsAndTimeline(GUID);
        return;
      }

      for(let i = 0 ; i < this.TASMarkers.length ; i++) {
        let marker = this.TASMarkers[i];
        if(marker['TASEvent']['JourneyGUID'] === GUID && 
        marker['TASEvent']['Remarks'] === remarks){
          this.markerClicked(marker);
          return;
        }
      }
      
    },

    groupTasPics: function (taspics) {
      if(!Array.isArray(taspics)){
        taspics = [taspics];
      }
      taspics.forEach((item) => {
        if (item["Event Type"].includes("Drop Off")) {
          item["Event Type"] = "Dropoff";
        } else {
          item["Event Type"] = "Pickup";
        }
      });

      let GUIDGroup = groupByGUID(taspics);

      for (let GUID in GUIDGroup) {
        GUIDGroup[GUID] = groupByEventType(GUIDGroup[GUID]);

        for (let event in GUIDGroup[GUID]) {
          for (let i = 0; i < GUIDGroup[GUID][event].length; i++) {
            GUIDGroup[GUID][event][i] = getSrc(GUIDGroup[GUID][event][i]);
          }
        }
      }

      return GUIDGroup;

      function groupByGUID(list) {
        let result = list.reduce(function (r, a) {
          r[a.JourneyGUID] = r[a.JourneyGUID] || [];
          r[a.JourneyGUID].push(a);
          return r;
        }, Object.create(null));
        return result;
      }

      function groupByEventType(list) {
        let result = list.reduce(function (r, a) {
          r[a["Event Type"]] = r[a["Event Type"]] || [];
          r[a["Event Type"]].push(a);
          return r;
        }, Object.create(null));
        return result;
      }

      function getSrc(pic) {
        // src = "data:image/jpeg;base64,[picimage]"
        let src = "data:" + pic["pictype"] + ";base64," + pic["picimage"];
        return src;
      }
    },

    getTASPicList: function (GUID, remark) {
      if (!this.TASPics) return null;
      if (!this.TASPics[GUID]) return null;
      if (!this.TASPics[GUID][remark]) return null;
      return this.TASPics[GUID][remark];
    },

    //#endregion

    //#region timeline functions

    getTimelinePeriodList: function (TAS, clockInOut) {
      // let fromDate = new Date(2022, 10, 11, 0, 0, 0, 0);
      // let toDate = new Date(2022, 10, 11, 23, 59, 0, 0);
      if(TAS.length === 0 && clockInOut.length === 0 ){
        return [];
      }
      let events = [...TAS];
      
      let fromDate = this.fromDate;
      let toDate = this.toDate;
      events.unshift({
        Time: fromDate,
        Remarks: "Day begins",
        'Event Type': "Day begins",
      });
      events.push({
        Time: toDate,
        Remarks: "Day ends",
        'Event Type': "Day ends",
      });

      events = structureTAS(events, clockInOut);

      // Get a list of periods of time between every event, and classify as productive or not.
      let periodList = getPeriodList(events);

      return periodList;


      // Get a list of periods of time between every event, and classify as productive or not.

      function getPeriodList(list) {
        const FACTOR = 1000000;
        let periodList = [];
        list.forEach((job, index) => { 
          let start = job[0];
            let end = job[job.length-1];
            let period = new Date(end['Time']) - new Date(start['Time']);
            let type = 'unproductive';
            if(start['Remarks'].includes('PUI') || end['Remarks'].includes('DOO')){
                type = 'productive';
            } else if(start['Event Type'].includes('Clock Out') || end['Event Type'].includes('Clock In') ){
                type = 'clock';
            }
            let GUID = start['JourneyGUID'] ? start['JourneyGUID']  : end['JourneyGUID']
            let uniqueId = 'period_' + index;
            periodList.push({
                Start : start,
                End : end,
                Period : period / FACTOR,
                Type: type,
                GUID: GUID,
                UniqueId: uniqueId
            })
        });
        return periodList;
      }


      function structureTAS(TAS, clockInOut) {
        if (clockInOut) {
          if (Array.isArray(clockInOut)) {
            clockInOut.forEach((o) => renameKey(o, "Clock Time", "Time"));
            clockInOut.forEach((o) =>
              renameKey(o, "Event GUID", "JourneyGUID")
            );
          } else {
            renameKey(clockInOut, "Event GUID", "JourneyGUID");
            renameKey(clockInOut, "Clock Time", "Time");
          }
        }
        let events = TAS;
        // clockInOut[0]['Time'] = new Date(2022,10,11,3,0,0,0);
        if (clockInOut) 
          events = TAS.concat(clockInOut);

        events.forEach((event) => {
          event["Time"] = new Date(event["Time"]);
        });

        events.sort(function (a, b) {
          var keyA = new Date(a["Time"]);
          var keyB = new Date(b["Time"]);
          // Compare the 2 dates
          if (keyA < keyB) return -1;
          if (keyA > keyB) return 1;
          return 0;
        });

        events = groupTASEvents(events);

        return events;

        function renameKey(o, oldKey, newKey) {
          if(o.hasOwnProperty(newKey))
            return;
          if (oldKey !== newKey && o.hasOwnProperty(oldKey)) {
            Object.defineProperty(
              o,
              newKey,
              Object.getOwnPropertyDescriptor(o, oldKey)
            );
            delete o[oldKey];
          }
        }

        function groupTASEvents(TAS) {
          let result = [];
          let group = [];

          TAS.forEach(event => {
              let remarks = event['Remarks'] ? event['Remarks'] : '';
              let type = event['Event Type'] ? event['Event Type'] : '';
              // group.push(remarks + ' ' + type);
              group.push(event);

              if(remarks.includes('DOO') || 
                  remarks.includes('PUI') || 
                  type.includes('Clock')
              ){
                  result.push(group);
                  group = [];
                  // group.push(remarks + ' ' + type);
                  group.push(event);
              }
          });
          result.push(group);
          // console.log("Group TAS Events: ", result);
          return result;
        }


      }
    },

    formatPeriodTime: function (period) {
      let hours = period["Start"]["Time"].getHours();
      hours = hours < 10 ? "0" + hours : hours;
      let minutes = period["Start"]["Time"].getMinutes();
      minutes = minutes < 10 ? "0" + minutes : minutes;
      return hours + ":" + minutes;
    },

    getPicSrc: function (period) {
      let src = this.deliveryTruckIcon; // If delivery

      let eventType = this.getPeriodEventType(period);
      if(eventType.charAt(0) === 'C')
        src = this.collectionTruckIcon; // If collection

      if (period["Type"] === "clock")
        src = this.clockOutIcon;
      if (period["Start"]["Event Type"] === "Clock In")
        src = this.clockInIcon;
      return src;
    },

    getPeriodEventType: function (period) {
      let eventType = "";
      if (!period["Start"]["Event Type"].includes('Day')) {
        eventType = period["Start"]["Event Type"].substring(0, 3);
      } else {
        eventType = period["End"]["Event Type"].substring(0, 3);
      }
      return eventType;
    },

    periodClicked(period) {
      // console.log("Period clicked: ", period);
      if (period["Type"] === "unproductive") {
        return
      }
      if(period['Start']['JourneyGUID']) {
        this.cardItemClicked(period['Start']);
      } else {
        this.cardItemClicked(period['End']);
      }
      return;
    },

    lastIsClock: function (index) {
      if (index === 0) return false;
      if (this.timelinePeriodList[index - 1]["Type"].includes("clock"))
        return true;
      return false;
    },

    getTimelineBarColor: function (type) {
      if(type === 'productive') return this.timelineProductiveColor
      else if(type === 'unproductive') return this.timelineUnproductiveColor
      else return this.timelineClockOutColor;
    },

    //#endregion

    //#region Map markers.
    addMapOverlays: function () {
      this.removeMapOverlays();
      
      this.TAS.forEach(TASEvent => {
        this.addTASMarker(TASEvent);
      })

      this.getTotalStopTime();
      this.stopPoints.forEach(point => {
        this.addStopPointMarker(point);
      })

      this.drawPolylines();

      this.zoomToFitMarkersInMap(this.allMarkersOnMap);
    },

    addTASMarker: function (TASEvent) {

      let latitude = TASEvent['Lat'];
      let longitude = TASEvent['Lon'];

      let pos = { lat: parseFloat(latitude), lng: parseFloat(longitude) };

      let icon = TASEvent["Remarks"].includes("PU") ? this.pickupIcon : this.dropoffIcon;

      if (!isNaN(latitude) && !isNaN(longitude)) {
        let marker = this.putMarker(pos, icon);
        marker['TASEvent'] = TASEvent;
        marker['event'] = 'TAS';
        this.TASMarkers.push(marker);
      }
    },

    drawPolylines: function() {
      // drawing the entire gps path
      this.GPSLogCoordinates = getGPSLogCoordinates(this.GPSLog);
      let polyline = this.makePolyline(this.GPSLogCoordinates, this.unproductivePathColor);
      polyline.setMap(this.myMap);
      this.GPSPath = polyline;
 
      let GUIDStartAndEndPoints = this.getGUIDStartAndEndPoints(this.GPSLog,this.TAS);

      // drawing each path of each GUID
      for(let GUID in GUIDStartAndEndPoints){
        if (!GUIDStartAndEndPoints[GUID]['Index']) {
        continue; // Skip this iteration if 'Index' is missing
        }
        let coordinates = this.GPSLogCoordinates.slice(
          GUIDStartAndEndPoints[GUID]['Index']['Start'],
          GUIDStartAndEndPoints[GUID]['Index']['End'],
        )
        
        polyline = this.makePolyline(coordinates, this.productivePathColor);
        polyline['GUID'] = GUID;
        polyline.setMap(this.myMap);
        this.allGUIDPaths.push(polyline);
      }

      function getGPSLogCoordinates(GPSLog) {
        let coordinates = [];
        GPSLog.forEach(log => {
          let coords = {
            lat: parseFloat(log['Lat']),
            lng: parseFloat(log['Lon']),
          };
          if(isNaN(coords['lat']) || isNaN(coords['lng'])){
            return;
          }
          coordinates.push(coords);
        });
        return coordinates;
      }
    },

    putMarker: function(pos, iconUrl) {
      let marker = new google.maps.Marker({
        position: pos,
        icon: {
          url: iconUrl,
          scaledSize: new google.maps.Size(40, 40),
        },
        map: this.myMap,
      });

      setTimeout(() => {
        this.$refs["vehicleMap"].addCustomMarker(marker);
      }, 300);

      return marker;
    },

    makePolyline: function(coordinates, strokeColor) {
      let polyline = new google.maps.Polyline({
        path: coordinates,
        geodesic: true,
        strokeColor: strokeColor,
        strokeOpacity: 1.0,
        strokeWeight: 2,
      });

      return polyline;
    },

    zoomToFitMarkersInMap: function(markerList) {
      let bounds = new google.maps.LatLngBounds();
      let hasValidPoints = false; // Track if there are valid points
      markerList.forEach(marker => {
        if (marker.TASEvent && (marker.TASEvent.Lat == "" || marker.TASEvent.Lon == "")) {
        // If TASEvent exists and Lat and Lon are empty, skip this marker
        return;
        }
        hasValidPoints = true; // Found at least one valid point
          bounds.extend(
            new google.maps.LatLng(
              marker.getPosition().lat(),
              marker.getPosition().lng()
            )
          );
      })
      if (hasValidPoints) {
        this.myMap.fitBounds(bounds);
        this.myMap.setZoom(this.myMap.getZoom()-1);
      }
    },

    removeMapOverlays: function () {
      this.removeAllMarkers();

      this.GPSLogCoordinates = [];
      this.removeGPSPath();
      this.removeAllGUIDPath();
    },

    removeGPSPath: function () {
      if (this.GPSPath) {
        this.GPSPath.setMap(null);
        this.GPSPath = null;
      }
    },

    removeAllGUIDPath: function () {
      this.allGUIDPaths.forEach(path => {
        path.setMap(null);
      })
      this.allGUIDPaths = [];
    },


    removeAllMarkers: function () {
      if (this.allMarkersOnMap) {
        this.allMarkersOnMap.forEach((marker) => {
          marker.setMap(null);
        });
        this.TASMarkers = [];
        this.stopPointMarkers = [];
        this.selectedMarker = null;
      }
    },

    addStopPointMarker: function (point) {
      let stopPoint = point["Start"];

      let latitude = stopPoint.Lat;
      let longitude = stopPoint.Lon;

      let pos = { lat: parseFloat(latitude), lng: parseFloat(longitude) };

      // if(this.TASMarkers.length > 0 && JSON.stringify(this.TASMarkers[this.TASMarkers.length-1].position) === JSON.stringify(pos)){
      //   pos = { lat: parseFloat(latitude)+0.1, lng: parseFloat(longitude) };
      // }

      if (!isNaN(latitude) && !isNaN(longitude)) {
        let marker = this.putMarker(pos, this.stopPointIcon);
        marker['StopDetails'] = point;
        marker['event'] = 'Stop';
        this.stopPointMarkers.push(marker);
      }
    },

    getInfoBoxDetails: function (TASDetails) {
      let remarks = TASDetails["Remarks"];
      remarks = remarks.includes("PU") ? "Pickup" : "Dropoff";
      let table = `
        <table style="font-size: 11px">
    <tr>
      <td style="font-weight: bold; padding-right: 20px">Consignment #</td>
      <td>${TASDetails["Consignment #"]}</td>
    </tr>
    <tr>
      <td style="font-weight: bold"><strong>Container #</strong></td>
      <td>${TASDetails["Container #"]}</td>
    </tr>
    <tr>
      <td style="font-weight: bold"><strong>Location</strong></td>
      <td>${TASDetails[remarks + " Company"]} (${TASDetails[remarks]}) - ${
        TASDetails[remarks + " City"]
      } </td>
    </tr>
    <tr>
      <td style="font-weight: bold"><strong>Remarks</strong></td>
      <td>${TASDetails["Remarks"]}</td>
    </tr>
    <tr>
      <td style="font-weight: bold"><strong>Time</strong></td>
      <td>${new Date(TASDetails["Time"]).formatString("yyyy-MM-dd HH:mm")}</td>
    </tr>
    <tr>
      <td style="font-weight: bold"><strong>Waiting Time</strong></td>
      <td>${this.getWaitTime(TASDetails)}</td>
    </tr>
  </table>
      `;
      return table;
    },

    getStopPointInfoBoxDetails: function (point) {
      let table = `
        <table style="font-size: 11px">
    <tr>
      <td style="font-weight: bold; padding-right: 20px">Stop Duration</td>
      <td>${point["Duration"]}</td>
    </tr>
    <tr>
      <td style="font-weight: bold"><strong>From</strong></td>
      <td>${new Date(point["Start"]["Time"]).formatString(
        "yyyy-MM-dd HH:mm"
      )}</td>
    </tr>
    <tr>
      <td style="font-weight: bold"><strong>To</strong></td>
      <td>${new Date(point["End"]["Time"]).formatString(
        "yyyy-MM-dd HH:mm"
      )}</td>
    </tr>
  </table>
      `;
      return table;
    },

    getAllJourneyGUID: function () {
        let GUIDList = this.TAS.map((a) => a["JourneyGUID"]);
        if(Array.isArray(this.clockInOut)){
          GUIDList = GUIDList.concat(this.clockInOut.map((a) => a["JourneyGUID"]))
        }
        else{
          GUIDList.push(this.clockInOut['JourneyGUID']);
        }

        return [...new Set(GUIDList)];
    },

    highlightCardsAndTimeline: function (GUID) {
      this.selectedGUID = GUID;

      GUID = "a" + GUID;
      this.scroll(GUID);
    },

    cardBackgroundColor: function(GUID) {
      let selected = this.timelineProductiveColor // blue
      let notSelected = 'white';

      let backgroundColor = GUID === this.selectedGUID ? selected : notSelected;

      return backgroundColor;
    },

    timelineOutline: function(GUID) {
      let selected = '5px solid ' + this.timelineHighlightColor;
      let notSelected = 'none';

      let outline = GUID === this.selectedGUID ? selected : notSelected;

      return outline;
    },

    timelineZIndex: function(GUID) {
      let selected = '999'
      let notSelected = '1';

      let zIndex = GUID === this.selectedGUID ? selected : notSelected;

      return zIndex;
    },

    scroll: function (GUID) {
      var collection = document.querySelectorAll("." + GUID);
      for(var i = collection.length-1 ; i >=0 ; i--){
        collection[i].scrollIntoView({
          behavior: "smooth"
        })
      }
      setTimeout(() => {
        collection.forEach(item => {
          item.scrollIntoView();
        })
      }, 200);
    },

    //#endregion

    refreshClicked: async function () {
      if (!this.selectedVehicle["Inventory #"]) return; //vehicle null check
      this.$fullscreenLoading("Getting GPSLog Data");
      this.fullVehicleData = await this.$apiCallV2(
        `/MovementHistory/GPS_GetGPSLog?vehicleno=${
          this.selectedVehicle["Inventory #"] ? this.selectedVehicle["Inventory #"] : ''
        }&start=${this.fromDate.formatString(
          "yyyy-MM-dd HH:mm"
        )}&end=${this.toDate.formatString("yyyy-MM-dd HH:mm")}` + 
        (this.$route.query.destinationCode ? `&destinationcode=${this.$route.query.destinationCode}` : '')
      );
      this.$fullscreenLoading();

      if (!this.fullVehicleData) return;

      this.fullVehicleData = this.fullVehicleData["Vehicle"];
      this.addMapOverlays();


      this.chronologyOfEventsCards = this.structureTASForCards(
        this.TAS,
        this.clockInOut
      );

      this.timelinePeriodList = this.getTimelinePeriodList(
        this.TAS,
        this.clockInOut
      );
      this.getTotalWaitTime();
      // console.log("timelinePeriodList: ", this.timelinePeriodList);
      
      // console.log("Taspics: ", this.TASPics);
    },

    //#region marker clicked functions

    markerClicked: async function (marker) {
      // console.log("Marker clicked: ", marker);
      this.selectedMarker = marker;
      if(marker['event'] === 'Stop') {
        this.setAllMarkersOpacity(1);
        marker.setZIndex(3);
        this.showInfoWindow(marker);
        return;
      }
      
      let GUID = marker['TASEvent']['JourneyGUID'];

      this.highlightAllMarkersWithSameGUID(GUID);
      marker.setZIndex(3);
      this.highlightGUIDPath(GUID);
      this.highlightCardsAndTimeline(GUID);
      
      this.showInfoWindow(marker);
    },

    highlightAllMarkersWithSameGUID: function(GUID) {
      
      this.setAllMarkersOpacity(0.25);
      this.moveAllMarkersZIndexBelow();
      
      this.TASMarkers.forEach(marker => {
        if(marker['TASEvent']['JourneyGUID'] === GUID) {
          marker.setOpacity(1);
          marker.setZIndex(2);
        }
      })

      let markerList = this.TASMarkers.filter(marker => {return marker['TASEvent']['JourneyGUID'] === GUID})
      this.zoomToFitMarkersInMap(markerList);
      //this.myMap.setZoom(this.myMap.getZoom()-1);
    },

    setAllMarkersOpacity: function(opacity) {
      this.allMarkersOnMap.forEach(marker => {
        marker.setOpacity(opacity);
      })
    },

    moveAllMarkersZIndexBelow: function() {
      this.allMarkersOnMap.forEach(marker => {
        marker.setZIndex(1);
      })
    },

    highlightGUIDPath: function (GUID) {

      let timeout = 50;
      this.allPaths.forEach(path => {
        path.setMap(null);
        if(path['GUID'] === GUID){
          path['strokeOpacity'] = 1;
        }
        else {
          path['strokeOpacity'] = 0.2;
        }

        setTimeout(() => {
          path.setMap(this.myMap);
        }, timeout);
      })
    },

    showInfoWindow: function(marker){
      if(this.infoWindow){
        this.infoWindow.close();
      }

      let infoBoxDetails = '';

      if(marker['event'] === 'Stop'){
        infoBoxDetails = this.getStopPointInfoBoxDetails(marker['StopDetails']);
      } else {
        infoBoxDetails = this.getInfoBoxDetails(
          marker['TASEvent']
        )
      }

      this.infoWindow = new google.maps.InfoWindow(
        {
            content: infoBoxDetails
        }
      );

      this.infoWindow.open(
        this.myMap,
        marker,
      );

      google.maps.event.addListener(
        this.infoWindow,
        'closeclick', 
        () => {
          this.resetMap()
        }
      );

    },

    resetMap: function () {
      this.infoWindow = null;
      this.selectedMarker = null;
      this.selectedGUID = '';
      let timeout = 50;
      this.allPaths.forEach(path => {
        path.setMap(null);

        path['strokeOpacity'] = 1;
        
        setTimeout(() => {
          path.setMap(this.myMap);
        }, timeout);
      })

      this.allMarkersOnMap.forEach(marker => {
        marker.setOpacity(1);
        marker.setZIndex(1);
      })

    },

    //#endregion


    //#region GUID Path functions

    getGUIDStartAndEndPoints: function (GPSLog, TAS) {
      let points = getGUIDStartAndEndCoordinates(TAS);
      let GUIDList = getAllJourneyGUID(TAS);
      let runningIndex = 0;

      GUIDList.forEach((GUID) => {
        if (!hasCoordinates(points[GUID]["TASDetails"])) {
          return;
        }
        let startTime = new Date(points[GUID]["TASDetails"]["Start"]["Time"]);
        let endTime = new Date(points[GUID]["TASDetails"]["End"]["Time"]);

        let startIndex = getClosestGPSPoint(startTime, GPSLog);
        let endIndex = getClosestGPSPoint(endTime, GPSLog);

        points[GUID]["Index"] = {
          Start: startIndex,
          End: endIndex,
        };
      });

      return points;

      function getClosestGPSPoint(TASTime, GPSLog) {
        for (; runningIndex < GPSLog.length; runningIndex++) {
          let GPSTime = new Date(GPSLog[runningIndex]["Time"]);

          if(GPSTime > TASTime)
            return runningIndex;
        }
        return 0;
      }

      function getGUIDStartAndEndCoordinates(TAS) {
        let GUIDList = getAllJourneyGUID(TAS);

        let startAndEndPoints = {};
        GUIDList.forEach((GUID) => {
          startAndEndPoints[GUID] = {};
        });

        GUIDList.forEach((GUID) => {
          let events = getAllPointsBasedOnGUID(GUID);

          let startPos = events[0];
          let endPos = events[events.length - 1];
          let startAndEndPos = { Start: startPos, End: endPos };

          startAndEndPoints[GUID]["TASDetails"] = startAndEndPos;
        });

        return startAndEndPoints;

        function getAllPointsBasedOnGUID(GUID) {
          return TAS.filter((rows) => rows["JourneyGUID"] === GUID);
        }
      }

      function getAllJourneyGUID(TAS) {
        let GUIDList = TAS.map((a) => a["JourneyGUID"]);
        return [...new Set(GUIDList)];
      }

      function hasCoordinates(TASDetails) {
        let lat1 = TASDetails["Start"]["Lat"];
        let lon1 = TASDetails["Start"]["Lon"];
        let lat2 = TASDetails["End"]["Lat"];
        let lon2 = TASDetails["End"]["Lon"];
        
        if (!lat1 || !lat2 || !lon1 || !lon2) return false;
        return true;
      }
    },

     getPolylineLength: function (polyline) {
      var lengthInMeters = google.maps.geometry.spherical.computeLength(
        polyline.getPath().getArray()
      );
      var lengthInKilometers = lengthInMeters / 1000;
      return lengthInKilometers;
     },

     
    getProductivePoints: function (GPSLog, TAS) {
      let points = getGUIDStartAndEndCoordinates(TAS);

      let GUIDList = getAllJourneyGUID(TAS);

      GUIDList.forEach((GUID) => {
        if (
          !points[GUID]["TASDetails"] ||
          !hasCoordinates(points[GUID]["TASDetails"])
        ) {
          return;
        }
        let startTime = new Date(points[GUID]["TASDetails"]["Start"]["Time"]);
        let endTime = new Date(points[GUID]["TASDetails"]["End"]["Time"]);

        let startIndex = getClosestGPSPoint(startTime, GPSLog);
        let endIndex = getClosestGPSPoint(endTime, GPSLog);

        points[GUID]["Index"] = {
          Start: startIndex,
          End: endIndex,
        };
      });
      return points;

      function getClosestGPSPoint(TASTime, GPSLog) {
        let max = Infinity;
        let closestIndex = 0;
        let difference = 0;
        for (var i = 0; i < GPSLog.length; i++) {
          let GPSTime = new Date(GPSLog[i]["Time"]);

          difference = timeDifference(TASTime, GPSTime);

          if (difference < max) {
            max = difference;
            closestIndex = i;
          }
        }
        return closestIndex;
      }

      function getGUIDStartAndEndCoordinates(TAS) {
        let GUIDList = getAllJourneyGUID(TAS);

        let startAndEndPoints = {};
        GUIDList.forEach((GUID) => {
          startAndEndPoints[GUID] = {};
        });

        GUIDList.forEach((GUID) => {
          let events = getAllPointsBasedOnGUID(GUID);

          let startPos = events.find((event) => {
            return event.Remarks.includes("PUO");
          });
          let endPos = events.find((event) => {
            return event.Remarks.includes("DOI");
          });

          if (startPos && endPos) {
            let startAndEndPos = { Start: startPos, End: endPos };
            startAndEndPoints[GUID]["TASDetails"] = startAndEndPos;
          }
        });

        return startAndEndPoints;

        function getAllPointsBasedOnGUID(GUID) {
          return TAS.filter((rows) => rows["JourneyGUID"] === GUID);
        }
      }

      function getAllJourneyGUID(TAS) {
        let GUIDList = TAS.map((a) => a["JourneyGUID"]);
        return [...new Set(GUIDList)];
      }

      function hasCoordinates(TASDetails) {
        let lat1 = TASDetails["Start"]["Lat"];
        let lon1 = TASDetails["Start"]["Lon"];
        let lat2 = TASDetails["End"]["Lat"];
        let lon2 = TASDetails["End"]["Lon"];

        if (!lat1 || !lat2 || !lon1 || !lon2) return false;
        return true;
      }

      function timeDifference(time1, time2) {
        return Math.abs(time1 - time2);
      }
    },

    //#endregion

    
    //#region Waiting Time and Stopping Time functions
    msToHrAndMin: function (duration) {
      var milliseconds = Math.floor((duration % 1000) / 100),
        seconds = Math.floor((duration / 1000) % 60),
        minutes = Math.floor((duration / (1000 * 60)) % 60),
        hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

      // hours = (hours < 10) ? "0" + hours : hours;
      // minutes = (minutes < 10) ? "0" + minutes : minutes;
      // seconds = (seconds < 10) ? "0" + seconds : seconds;

      if (duration < 60000) return "<1 min";
      else if (hours === 0) return minutes + " min";
      else return hours + " hr " + minutes + " min";
      // + seconds + "." + milliseconds;
    },

    timeDifference: function (pair) {
      if (pair.length == 1) {
        return 0;
      }

      let time1 = new Date(pair[0]["Time"]);
      let time2 = new Date(pair[1]["Time"]);

      return time2 - time1;
    },

    findPair: function (GUID, remark) {
      // remark is DO / PU
      let ans = this.TAS.filter((tasDetails) => {
        return tasDetails["JourneyGUID"] === GUID;
      }).filter((tasDetails) => {
        return tasDetails["Remarks"].includes(remark);
      });
      return ans;
    },

    getWaitTime: function (point) {
      let GUID = point["JourneyGUID"];
      let remark = point["Remarks"].substring(1, 2); // gets "DO" or "PU"
      let pair = this.findPair(GUID, remark);
      if (Array.isArray(pair) && pair.length < 2) {
        return 0;
      }
      let waitTime = this.timeDifference(pair);
      return this.msToHrAndMin(waitTime);
    },

    getWaitTimeInMs: function (point) {
      let GUID = point["JourneyGUID"];
      let remark = point["Remarks"].substring(1, 2); // gets "DO" or "PU"
      let pair = this.findPair(GUID, remark);
      let waitTime = this.timeDifference(pair);
      return waitTime;
    },

    getTotalWaitTime: function () {
      let totalWaitTime = 0;
      if (this.toDate <= this.fromDate) {
          this.waitTimePercentage = 0;
          return totalWaitTime; // return 0 if to date is before from date
      }
      if(!this.TAS || this.TAS.length === 0){ // if no record found from TAS, read waiting time from GeofenceInOut
          const waitingTimes = this.geofenceInOut.reduce((total, entry) => total + (entry['Waiting Time'] * 60000), 0);
          totalWaitTime = waitingTimes;
      }else{
      this.TAS.forEach((TASDetails) => {
          if (
            TASDetails["Remarks"].includes("PUI") ||
            TASDetails["Remarks"].includes("DOI")
          ) {
            totalWaitTime += this.getWaitTimeInMs(TASDetails);
          }
        });
      }
      this.totalWaitTimeInMs = totalWaitTime;
      this.waitTimePercentage = this.getWaitTimePercentage();
      return totalWaitTime;
    },

    getTotalJourneyTime: function () {
      let time1 = new Date(this.GPSLog[0]["Time"]);
      let time2 = new Date(this.GPSLog[this.GPSLog.length - 1]["Time"]);
      let totalJourneyTime = time2 - time1;
      return totalJourneyTime;
    },

    getWaitTimePercentage: function () {
      let percentage = (this.totalWaitTimeInMs / this.getTotalJourneyTime()) * 100;
      // handle the case when TotalWaitingTime is retrieved from GeofenceInOut and exceeds the GPS Log Time.
      // if the calculated percentage exceeds 100%, default it to 100.
      if (percentage > 100) {percentage = 100; } 
      return percentage;
      //return (this.totalWaitTimeInMs / this.getTotalJourneyTime()) * 100;
    },

    getTotalStopTime: function () {
      if(!this.GPSLog || this.GPSLog.length === 0){
        this.stopTimePercentage = 0;
        this.stopPoints = [];
        return 0;
      }
      this.stopPoints = [];
      let currentLog = this.GPSLog[0];
      let totalTime = 0;
      let stopTime = 0;
      this.GPSLog.forEach((log) => {
        if (!sameSpot(currentLog, log)) {
          stopTime = timeBetween(currentLog, log);
          if (stopTime > 600000) {
            totalTime += stopTime;
            this.stopPoints.push({
              Start: currentLog,
              End: log,
              Duration: this.msToHrAndMin(stopTime),
            });
          }
          currentLog = log;
        }
      });

      this.stopTimePercentage = (totalTime / this.getTotalJourneyTime()) * 100;
      return this.msToHrAndMin(totalTime);

      function sameSpot(log1, log2) {
        return log1["Lat"] === log2["Lat"] && log1["Lon"] === log2["Lon"];
      }

      function timeBetween(log1, log2) {
        let time1 = new Date(log1["Time"]);
        let time2 = new Date(log2["Time"]);
        return Math.abs(time1 - time2);
      }
    },

    toggleStopMarkers: function () {
      if(this.stopPointMarkers.length === 0){
        return;
      }
      
      if(this.selectedMarker && this.selectedMarker['event'] === 'Stop'){
        this.infoWindow.close();
      }
      
      if(this.stopPointToggleText.includes('Hide')){
        this.stopPointToggleText = 'Show stop markers'
        this.stopPointMarkers.forEach(marker => {
          marker.setMap(null);
        })
      } else {
        this.stopPointToggleText = 'Hide stop markers'
        this.stopPointMarkers.forEach(marker => {
          marker.setMap(this.myMap);
        })
      }
    },

    //#endregion

    //#region gallery functions
    startGallery: function (list) {
      this.galleryPopupDisplay = 'block';
      
      // console.log("List: ", list);
      this.galleryPics = list;
      // console.log("gallerypics: ", this.galleryPics);
      // displayGallery();
      if (this.galleryPics.length > 0)
        this.selectedPicIndex = 0;


    },

    getThumbnailBackgroundColor: function (index) {
      const notHighlighted = 'white';
      const highlighted = 'green'
      let color =  index === this.selectedPicIndex ? highlighted : notHighlighted;
      return color;
    },

    displayPrev: function () {
      // console.log("Display prev");
      if (this.selectedPicIndex === 0)
        this.selectedPicIndex = this.galleryPics.length - 1;
      else this.selectedPicIndex--;
    },

    displayNext: function () {
      // console.log("Display next");
      if (this.selectedPicIndex === this.galleryPics.length - 1)
        this.selectedPicIndex = 0;
      else this.selectedPicIndex++;
    },

    //#endregion
    getGeofenceInEntriesInPeriod: function(period) {
      if (!this.geofenceInOut || this.geofenceInOut.length === 0) return [];

      const periodStart = new Date(period['Start']['Time']);
      const periodEnd   = new Date(period['End']['Time']);

      return this.geofenceInOut.filter(geo => {
        if (!geo['GPSLogTime']) return false;
        const logIn = new Date(geo['GPSLogTime']);
        if (!(logIn >= periodStart && logIn <= periodEnd)) return false;

        // Only show in the FIRST period that contains this Log Time
        const firstMatchingPeriod = this.timelinePeriodList.find(p => {
          const pStart = new Date(p['Start']['Time']);
          const pEnd   = new Date(p['End']['Time']);
          return logIn >= pStart && logIn <= pEnd;
        });

        return firstMatchingPeriod && firstMatchingPeriod['UniqueId'] === period['UniqueId'];
      });
    },

    getGeofenceOutEntriesInPeriod: function(period) {
      if (!this.geofenceInOut || this.geofenceInOut.length === 0) return [];

      const periodStart = new Date(period['Start']['Time']);
      const periodEnd   = new Date(period['End']['Time']);

      return this.geofenceInOut.filter(geo => {
        if (!geo['GPSLogTimeOut']) return false;
        const logOut = new Date(geo['GPSLogTimeOut']);
        if (!(logOut >= periodStart && logOut <= periodEnd)) return false;

        // Only show in the FIRST period that contains this GPSLogTimeOut
        const firstMatchingPeriod = this.timelinePeriodList.find(p => {
          const pStart = new Date(p['Start']['Time']);
          const pEnd   = new Date(p['End']['Time']);
          return logOut >= pStart && logOut <= pEnd;
        });

        return firstMatchingPeriod && firstMatchingPeriod['UniqueId'] === period['UniqueId'];
      });
    },

    // Calculates top % offset for a specific time within the period for geofence line 
    getGeofenceOffsetInPeriod: function(period, time) {
      const periodStart    = new Date(period['Start']['Time']).getTime();
      const periodEnd      = new Date(period['End']['Time']).getTime();
      const periodDuration = periodEnd - periodStart;

      if (periodDuration === 0) return 0;

      const geoTime = new Date(time).getTime();
      const offset  = ((geoTime - periodStart) / periodDuration) * 100;

      return Math.min(Math.max(offset, 2), 95);
    },

    getGeofenceTimesForJourney(GUID) {
      if (!this.geofenceInOut || this.geofenceInOut.length === 0) return [];
      return this.geofenceInOut
        .filter(geo => geo['JourneyGUID'] === GUID)
        .map(geo => ({
          in:  geo['GPSLogTime']    || null,
          out: geo['GPSLogTimeOut'] || null,
        }));
    },
  },
  async mounted() {
    this.$fullscreenLoading("Getting Vehicle Data");
    // this.vehicles = await this.$apiCallV2("/MovementHistory/GetListMaster");
    this.vehicles = await this.$apiCallV2("/Master/GetListMaster", { "masterfile": "VEHICLE_MVTHISTORY", "module": "HMS" });
    if (this.vehicles.length > 0) {
        this.vehicles = this.$jsonNullToStringV2(this.vehicles)
        this.vehicles = this.$deepTrimJsonV3(this.vehicles);

        let vehicleArr = this.vehicles.map(i => {
          i['Keyname'] = `${i['Inventory #']} (${i['Inventory Code']})`
          return i;
        })

        this.vehicles = vehicleArr;
    }
    this.$fullscreenLoading();

    document.getElementById('gallery-popup').addEventListener("wheel", (event) => {
      event.preventDefault();
      event.deltaY < 0 ? this.displayPrev() : this.displayNext();
    });

    if (this.$route.query.destinationCode) {
      const APIResult = (await this.$apiCallV2(`/DestinationList/GetDetailsMaster?recordID=${this.$route.query.destinationCode}`));
      if(APIResult)
      {
        const geofencePath2 = APIResult["Destination"]["Geofence"].map(g => ({lat: parseFloat(g['gfLat']),lng: parseFloat(g['gfLon'])}));
        geofencePath2.push({lat: parseFloat(APIResult["Destination"]["Geofence"][0]["gfLat"]), lng:  parseFloat(APIResult["Destination"]["Geofence"][0]["gfLon"])});

        for(let i = 0 ; i <= APIResult["Destination"]["Geofence"].length ; i++)
        {
          let latitude = APIResult["Destination"]["Geofence"][i]?.["gfLat"];
          let longitude = APIResult["Destination"]["Geofence"][i]?.["gfLon"];
          let pos = { lat: parseFloat(latitude), lng: parseFloat(longitude) };

          if (!isNaN(latitude) && !isNaN(longitude)) {
            let marker = this.putMarker(pos, '');
            marker['Geofence'] = APIResult["Destination"]["Geofence"];
            marker['event'] = 'geofences';
            this.destGeofenceList.push(marker);
          }
        }

        this.mapMarker = [
          ...this.mapMarker,
          {
            position: {
              lat: parseFloat(APIResult["Destination"]["Geofence"][0]["gfLat"]),
              lng: parseFloat(APIResult["Destination"]["Geofence"][0]["gfLon"]),
            },
            geofence: geofencePath2,
          }
        ];
      }
    }
    this.showCustomMap = true;

    if (this.$route.query.fromDate) {
      this.fromDate = new Date(this.$route.query.fromDate);
    }
    if (this.$route.query.toDate) {
      this.toDate = new Date(this.$route.query.toDate);
    }
    if (this.$route.query.vehicleCode) {
      const foundVehicle = this.vehicles.find((vehicle) => {
        return vehicle["Inventory Code"] === this.$route.query.vehicleCode;
      });
      if (foundVehicle) {
        this.selectedVehicle = foundVehicle;
        this.refreshClicked();
      }
    }
  },
  watch: {
  },
};
</script>


<style lang="scss" scoped>
@import "@/css/all.scss";

table {
  font-size: 11px;
  margin: 5px;
}

.movement-history-main {
  font-size: 12px;
  width: 100%;
  height: 100%;
  padding: 10px 45px;
  display: flex;

  > .left-container {
    height: 100%;
    min-width: 200px;
    background-color: white;
    border-radius: 5px;
    padding: 5px;
    display: flex;
    flex-direction: column;
    transition: $transition-time;
    overflow: hidden;

    > .section-title {
      display: flex;
      justify-content: space-between;

      > .title-text {
        align-self: center;
      }
    }

    > .date-refresh-section {
      display: flex;
      align-items: center;

      > .from-to-date {
        flex-grow: 1;
      }

      > button {
        height: fit-content;
      }
    }

    > .vehicle-dropdown-section {
      > .vehicle-description {
        width: 100%;
        // height: 100%;
        margin: 5px auto;
        border: 1px solid rgb(200, 200, 200);
        padding: 5px;
      }
    }

    > .filter-table {
      width: 100%;
      height: calc(100% - 125px);
      flex-grow: 1;

      > .customer-filter {
        width: 100%;
        height: calc(100% - 50%);
      }

      > .eventtype-filter {
        width: 100%;
        height: 50%;
      }
    }

    > .extra-info {
      // display: flex;
      // flex-direction: column;
      // text-align: center;

      width: 100%;
      // height: 100%;
      margin: 5px auto;
      border: 1px solid rgb(200, 200, 200);
      padding: 5px;
      max-height: 50vh;
      overflow: auto;

      .longest-shortest-journey {
        // border: 2px solid rgb(0, 194, 194);
        // border-radius: 10px;
        // padding: 0 10px;
        &:hover {
          cursor: pointer;
          // text-decoration: underline;
        }
      }

      > .gauge-container {
        width: 100%;
        background-color: rgb(200, 200, 200);
        border-radius: 5px;

        > .progress-bar {
          width: 1%;
          height: 15px;
          background-color: rgb(255, 0, 0);
          border-radius: 5px;
        }
      }
    }
  }

  > .map,
  .chronology {
    height: 100%;
    width: 100%;
    background-color: white;
    border-radius: 5px;
    padding: 10px;
    margin-left: 5px;
    display: flex;
    flex-direction: column;
    overflow: auto;

    > .card-container {
      // background-color:bisque;
      > .event-container {
        border-radius: 10px;
        > .card-box {
          // border: 1px solid red;
          display: flex;
          // display: grid;
          // grid-template-columns: 2fr 1fr;
          // grid-template-areas: "div1 div2";
          // grid-gap: 20px;
          padding: 10px;

          > .card {
            // border: 2px solid rgb(91, 155, 213);
            border: 2px solid rgb(0, 194, 194);
            padding: 5px;
            width: 100%;
            border-radius: 10px;
            &:hover {
              cursor: pointer;
              background-color: rgb(250, 250, 250);
            }
            // margin: 10px;

            > .card-title {
              font-size: 0.9em;
              //width: fit-content;
              display: flex;
              align-items: center;
              justify-content: space-between;

              > .time {
                > .underline:hover {
                  // text-decoration: underline;
                  font-weight: bold;
                  cursor: pointer;
                }
              }

              > .remark {
                font-weight: bold;
                margin-right: 10px;
              }

              > .tooltip-container {
                position: relative;
                margin-left: auto; 
                > .tooltip {
                  position: absolute;
                  top: 0; 
                  right: 0; 
                  width: 50px;
                  height: 50px;
                  background-color: yellow; 
                }
              }

              > .geofence-time {
                margin-left: 8px;
                border-left: 2px solid rgb(200, 200, 200);
                padding-left: 6px;

                > .geofence-time-entry {
                  white-space: nowrap;

                  // > div {
                  //   font-weight: bold; 
                  // }
                }
              }
            }

            > .card-paragraph {
              padding: 0;
              // border: 1px solid red;
              display: flex;
              justify-content: space-between;
              align-items: center;

              > .details {
                // border: 1px solid red;
                // max-width: 75%;
                width: fit-content;
                overflow-wrap: break-word;
              }
              > .tas-pic-container {
                position: relative;
                > .tas-pic {
                  width: 50px;
                  height: 50px;
                  margin: 0;
                  padding: 0;

                  &:hover {
                    cursor: pointer;
                  }
                }
                > .number {
                  font-weight: bold;
                  text-align: center;
                  color: white;
                  background-color: red;
                  position: absolute;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  height: 1.5em;
                  width: 1.5em;
                  border-radius: 1.5em;
                  top: -0.5em;
                  // top: -1px;
                  right: -0.5em;
                }
              }
            }

            > .space {
              height: 10px;
              background-color: lightgrey;
            }
          }

          > .red {
            display: initial;
            border: 2px solid rgb(255, 80, 80);
            background-color: rgb(255, 80, 80);
            width: 25%;
            color: white;
            // height: 100%;

            &:hover {
              cursor: pointer;
              background-color: rgb(255, 80, 80);
            }
          }

          > .clock-in{
            width: 50%
          }

          > .clock-out {
            width: 50%;
            border: 2px solid rgb(255, 80, 80);
            margin-left: auto;
          }
        }

        // > .clock-out {
        //   grid-area: div2;
        // }
      }
    }
  }

  > .timeline-container {
    height: 100%;
    width: 600px;
    background-color: white;
    border-radius: 5px;
    padding: 10px;
    // margin-left: 5px;
    // display: flex;
    // flex-direction: column;
    overflow: auto;
    position: relative;

    > #timeline-title-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      > #timeline-title {
        font-weight: bold;
        font-size: 1.25em;
      }
      > #legend-title {
        border-radius: 5px;
        background-color: rgb(240, 240, 240);
        padding: 0 10px; 
        &:hover {
          cursor: pointer;
        }

        > #legend-container {
          position: absolute;
          top: 2.5em;
          left: 5%;
          width: 90%;
          z-index: 999999;
          background-color: white;
          border: 1px solid grey;
          border-radius: 10px;
          padding: 10px 20px;

          > .legend-item {
            > .legend-symbol{
              height: 2em;
              width: 2em;

              > img{
                max-height: 100%;
                max-width: 100%;
              }
            }
            > .legend-description {
              padding-left: 5px;
            }
          }
          
        }
      }

    }

    > #timeline {
      // background-color: rgb(255, 73, 73);
      width: 40px;
      margin: auto;
      margin-top: 2em;
      color: black;
      text-align: center;
      position: relative;
      font-weight: bold;
      font-size: 0.8em;
      overflow: visible;

      > .timeline-time{
        margin-top: 5px;
      }

      > .timeline-bar{
        position: relative;
        overflow: visible !important;
        z-index: auto !important;
        // border-top: 1px solid rgb(255, 255, 255);
        // opacity: 0.7;
        .geofence-marker-container {
          position: absolute;
          inset: 0 auto auto 0;
          width: 100%;
          pointer-events: none; 
          z-index: 99999 !important;
          overflow: visible;

          .geofence-line {
            position: absolute;
            left: 0px;
            width: 100%;
            height: 6px;
            border-radius: 2px;
            pointer-events: all; 
            z-index: 99999 !important; 

            &:hover .geofence-hover-label {
              display: block;
              white-space: nowrap;
              font-size: 10px;
              font-weight: bold;
              background-color: rgba(0, 0, 0, 0.75);
              color: white;
              border-radius: 4px;
              padding: 2px 6px;
              pointer-events: none;
              z-index: 9999;    
            }
          }

          .geofence-line-in {
            background-color: #5bb450; 
          }

          .geofence-line-out {
            background-color: #ffa500; 
          }

          .geofence-hover-label {
            display: none;
            position: absolute;
            left: 105%; 
            top: -6px;
            white-space: nowrap;
            font-size: 10px;
            font-weight: bold;
            background-color: rgba(0, 0, 0, 0.75);
            color: white;
            border-radius: 4px;
            padding: 2px 6px;
            pointer-events: none;
            z-index: 9999;
          }
        }

        .time-display {
          position: absolute;
          // top: -5px;
          z-index: 5;
          .time {
            display: flex;
            // border: 1px solid red;
            position: absolute;
            color: black;
            left: 60px;
            margin-top: -0.9em;
            // background-color: rgb(255, 255, 255);
            // background-color: red;
            z-index: 1;
            > div {
              margin-left: 5px;
            }
          }
          .right-line {
            position: absolute;
            border-bottom: 1px solid rgb(90, 90, 90);
            width: 10px;
            bottom: 0;
            left: 45px;
          }
        }
        .pic-container {
          position: absolute;
          // border: 1px solid red;
          // background-color: grey;
          height: 25px;
          width: 25px;
          // size: fit-content;
          top: 50%;
          right: 80px;
          transform: translateY(-50%);
          // z-index: -1;

          > .short-desc {
            color: rgb(108, 108, 108);
            // border: 1px solid red;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            right: 40px;
            white-space: nowrap;
            font-weight: bold;
          }
          > .event-type {
            position: absolute;
            top: 4px;
            color: white;
            font-weight: 100;
            font-size: 80%;
          }
          > .right {
            right: 1px;
          }
        }

        .left-line {
          position: absolute;
          border-top: 1px solid rgb(90, 90, 90);
          width: 30px;
          top: 50%;
          right: 45px;
          transform: translateY(-50%);
        }

        &:hover {
          // border: 5px solid bisque;
          // margin: 2px;
          opacity: 1;
          transition: 0.5s;
          cursor: pointer;
          border-radius: 5px;
          z-index: 5000 !important;
        }
      }

      // .time{
      //     // margin-top: 0.5em;
      // }

      .event-info {
        position: absolute;
        border: 1px solid yellow;
        background-color: red;
        left: -150%;
      }

      > .line {
        border-top: 5px solid white;
      }
    }
  }

  > #gallery-popup {
    background-color: white;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    border-radius: 10px;
    height: 90vh;
    width: 90vw;
    z-index: 999999;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    // opacity: 0.1;
    // display: none;

    > #gallery-popup-close-button {
      opacity: 1;
      position: absolute;

      display: flex;
      justify-content: center;
      align-items: center;

      right: 10px;
      top: 10px;
      height: 2em;
      width: 2em;

      background-color: red;
      border-radius: 10px;
      background-color: red;
      color: white;
      font-weight: bold;
      &:hover {
        cursor: pointer;
      }
    }

    #large {
      width: 65vw;
      height: 65vh;
      // background: #000 url(http://lh5.googleusercontent.com/-ugFamEhbqPo/Thc6hoArbwI/AAAAAAAAABA/PFeHcJhR4Xw/s800/image1.jpg) no-repeat center;
      background: no-repeat center;
      background-size: contain;
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: white;
      > .arrow-buttons-container {
        width: 100%;
        position: absolute;
        display: flex;
        justify-content: space-between;
        align-items: center;
        > .prev,
        .next {
          background-color: rgba(0, 0, 0);
          border-radius: 10px;
          margin: 5px;
          opacity: 0.25;
          font-weight: bold;
          padding: 15px;
          font-size: 2em;

          -webkit-user-select: none; /* Safari */
          -moz-user-select: none; /* Firefox */
          -ms-user-select: none; /* IE10+/Edge */
          user-select: none; /* Standard */

          &:hover {
            cursor: pointer;
            opacity: 1;
          }
        }
      }
      > .img-container {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        > img {
          margin: auto;
          max-height: 100%;
          max-width: 100%;
        }
      }
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
        0 6px 20px 0 rgba(0, 0, 0, 0.19);
      border-radius: 10px;
    }

    #thumbs {
      padding-top: 12px;
      overflow: auto;
      white-space: nowrap;
      max-width: 448px;
      display: flex;
      /* align-items: center; */
      /* justify-content: center; */
      > img {
        max-width: 80px;
        max-height: 60px;
        object-fit: contain;
        padding: 2px;
        cursor: pointer;

        &:hover {
          background-color: rgb(152, 255, 93) !important;
        }
      }
    }

    #gallery {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    #container {
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
  }
}
.tooltip-wrapper {
  margin-left: 300px; 
  position: relative; 
}

.tooltip {
  position: absolute;
  top: 50%; 
  left: calc(100% + 20px); 
  transform: translateY(-50%); 
  z-index: 100;
}
</style>